import { render, staticRenderFns } from "./AdaptiveGrid.vue?vue&type=template&id=05487c78&scoped=true&"
import script from "./AdaptiveGrid.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AdaptiveGrid.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AdaptiveGrid.vue?vue&type=style&index=0&id=05487c78&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05487c78",
  null
  
)

export default component.exports